<div class="modal-header py-2 bg-dark text-light">
    <h4 class="modal-title">
        그룹정보
    </h4>
</div>

<div class="modal-body">
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                ID
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm"
                    formControlName="dtgTeamId"
                    readonly>
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                그룹이름
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm"
                    formControlName="dtgTeamNm"
                    [ngClass]="{'is-invalid':submitted && f.dtgTeamNm.errors}"
                    required
                    ngbAutofocus>
                <div class="invalid-tooltip" *ngIf="submitted && f.dtgTeamNm.errors">
                    <div *ngIf="f.dtgTeamNm.errors.required">필수 입력 항목 입니다</div>
                </div>
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                위도
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm"
                    formControlName="lat">
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                경도
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm"
                    formControlName="lng">
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                주소
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm"
                    formControlName="addr1">
            </div>
        </div>

        <div class="form-group row align-items-center mb-0">
            <label class="col-md-3 mb-0">
                사용여부
            </label>
            <div class="col-md-9 position-relative">
                <select class="form-control form-control-sm w-auto"
                    formControlName="useYn">
                    <option [ngValue]="'Y'">사용</option>
                    <option [ngValue]="'N'">미사용</option>
                </select>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-success btn-sm"
        (click)="clickSave()"
        [hidden]="dtgActionType === DtgActionType.read">
        <i class="mdi mdi-content-save"></i>
        <span class="ml-1">
            저장
        </span>
    </button>
    <button type="button" class="btn btn-secondary btn-sm"
        (click)="clickCancel()">
        <i class="mdi mdi-close"></i>
        <span class="ml-1">
            취소
        </span>
    </button>
</div>
